import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getArticles(page: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/getArticles?page=' + page);
    }

    getUserArticles(page: any, userId: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/getUserArticles?page=' + page + '&userId=' + userId);
    }
    getAticlePost(articleId: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/getAticlePost?articleId=' + articleId);
    }
    getArticleById(articleId: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/getArticleById?articleId=' + articleId);
    }

    getArticleApprovalHistory(articleId: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/getArticleApprovalHistory?articleId=' + articleId);
    }

    createArticle(article: any): any {

        //let _authorizationData = this.authentication._authentication;
        //let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Articles/createArticle', article);
    }

    createArticleApproval(articleApproval: any): any {

        //let _authorizationData = this.authentication._authentication;
        //let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Articles/createArticleApproval', articleApproval);
    }

    updateViewCount(articleId: any): any {
        return this.http.get(this.common.apiServiceURL + 'Articles/updateViewCount?articleId=' + articleId);
    }

}
